"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEETINGS_APP_NAME = exports.NEW_LINK_ID = void 0;
var NEW_LINK_ID = 'new';
exports.NEW_LINK_ID = NEW_LINK_ID;
var MEETINGS_APP_NAME = 'meetings';
exports.MEETINGS_APP_NAME = MEETINGS_APP_NAME;